import styled from 'styled-components'

export const LegalText = styled.p`
  color: ${({ theme }) => theme.colors.textColor};
  font-weight: bold;

  a {
    color: ${({ theme }) => theme.colors.inverseColor};
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.colors.secondary};
      text-decoration: underline;
    }
  }
`
